import { useState } from "react";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import styles from "./supportModal.module.scss";
import CloseIcon from "@mui/icons-material/Close";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import { useAppDispatch, useAppSelector } from "src/page/store";
import { fetchUserListAction } from "src/page/walletDetail/walletDetailSlice";
import { debounce } from "lodash";
import { EMPTY_STRING, PARTICIPANT, roleMapping } from "src/components/constant/constant";
import { roleColors } from "src/variable/randomColor";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { getRoleForOrganisation } from "src/utils/roleUtils";

interface Iprops {
  handleClose: () => void;
  participant?: boolean;
  participantName: string;
  organisationId?: number;
  hideConnectToAll?: boolean;
  loading?: boolean;
  onAddSupporter: (_email: string, _userId: string, _close: boolean, _connectedToParticipant: boolean) => void;
}

export default function SupporterModal({
  handleClose,
  participantName,
  onAddSupporter,
  hideConnectToAll = false,
  loading = false,
  participant = false
}: Iprops) {
  const [supporterEmail, setSupporterEmail] = useState<string>(EMPTY_STRING);
  const [supporterEmailId, setSupporterEmailId] = useState<string>(EMPTY_STRING);
  const [connectToParticipant, setConnectToParticipant] = useState<boolean>(false);
  const [error, setError] = useState({ email: EMPTY_STRING });

  const { cognitoConfig } = useAppSelector((state) => state.auth);
  const { users } = useAppSelector((state) => state.walletDetail);
  const dispatch = useAppDispatch();

  const handleAddAndClose = () => {
    if (!supporterEmail.trim()) {
      setError({
        email: supporterEmail ? EMPTY_STRING : "User email is required"
      });
      return;
    }
    onAddSupporter(supporterEmail, supporterEmailId, true, connectToParticipant);
  };

  const handleAddAndStay = () => {
    if (!supporterEmail.trim()) {
      setError({
        email: supporterEmail ? EMPTY_STRING : "User email is required"
      });
      return;
    }
    onAddSupporter(supporterEmail, supporterEmailId, false, connectToParticipant);
  };

  const handleCancelClose = () => {
    handleClose();
  };

  const handleRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setConnectToParticipant(e.target.value === "Yes");
  };

  const handleInputChange = debounce((event: React.ChangeEvent<object>, input: string) => {
    if (input.length < 2) return;
    const data = {
      from: 0,
      limit: 200,
      // isActive: true,
      full_name: input,
      ...(participant && { role: PARTICIPANT })
    };

    dispatch(fetchUserListAction(data));
  }, 500);

  return (
    <div className={styles.referModalBox}>
      <main className={styles.referModalTop}>
        <form>
          <div className={styles.close}>
            <h5>Connect User to {participantName}</h5>
            <button onClick={handleCancelClose} aria-label="close">
              <CloseIcon />
            </button>
          </div>

          <div className={styles.email}>
            <label htmlFor="email">User</label>
            <Autocomplete
              id="email"
              options={users.list}
              getOptionLabel={(option) => `${option.email}, ${option.firstName} ${option.lastName}`}
              style={{ width: 300 }}
              filterOptions={(x) => x}
              onInputChange={handleInputChange}
              onChange={(event, newValue) => {
                setSupporterEmailId(newValue?.userId + EMPTY_STRING || EMPTY_STRING);
                setSupporterEmail(newValue?.email || EMPTY_STRING);
              }}
              renderInput={(params) => <TextField {...params} variant="outlined" placeholder="search user by name" />}
              renderOption={(props, option) => (
                <li
                  {...props}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start"
                  }}
                >
                  <span>{`${option.firstName} ${option.lastName}`}</span>
                  <span style={{ color: "#64748B" }}>{option.email}</span>
                  <span
                    style={{
                      border: `1px solid ${
                        roleColors[
                          getRoleForOrganisation(
                            option?.role,
                            String(cognitoConfig?.currentOrganisation?.organisation_id)
                          ) || "NOROLE"
                        ]
                      }73`,
                      backgroundColor: `${
                        roleColors[
                          getRoleForOrganisation(
                            option?.role,
                            String(cognitoConfig?.currentOrganisation?.organisation_id)
                          ) || "NOROLE"
                        ]
                      }33`,
                      borderRadius: "4px",
                      padding: "2px"
                    }}
                  >
                    {
                      roleMapping[
                        getRoleForOrganisation(
                          option?.role,
                          String(cognitoConfig?.currentOrganisation?.organisation_id)
                        ) || "NOROLE"
                      ]
                    }
                  </span>
                </li>
              )}
              ListboxProps={{ style: { maxHeight: "200px", overflow: "auto" } }}
            />
            {/* ) : (
              <input
                type="email"
                placeholder="example@gmail.com"
                value={supporterEmail}
                onChange={(e) => setSupporterEmail(e.target.value)}
                required
              />
            )} */}
            {error.email && (
              <div className={styles.error}>
                <ErrorOutlineIcon className={styles.errIcon} />
                {error.email}
              </div>
            )}
          </div>
          {!hideConnectToAll && (
            <div className={styles.RadioInput}>
              <label>Connect to all of this participant’s wallet?</label>
              <div className={styles.inputs}>
                <div className={styles.inputYes}>
                  <input type="radio" name="connectOption" value="Yes" id="yes" onChange={handleRadioChange} />
                  <label htmlFor="yes">Yes</label>
                </div>
                <div className={styles.inputNo}>
                  <input type="radio" name="connectOption" value="No" id="No" onChange={handleRadioChange} />
                  <label htmlFor="No">No</label>
                </div>
              </div>
            </div>
          )}
        </form>
      </main>
      <footer className={styles.referModalBottom}>
        <div className={styles.referModalBtn}>
          <Stack spacing={2} direction="row">
            <Button
              className={styles.cancelBtn}
              variant="text"
              onClick={handleAddAndClose}
              aria-label="secondary button"
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} style={{ color: "white" }} /> : "Connect & Back To List"}
            </Button>
            <Button
              className={styles.sendBtn}
              variant="contained"
              onClick={handleAddAndStay}
              aria-label="primary button"
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} style={{ color: "white" }} /> : "Connect & Add Another User"}
            </Button>
          </Stack>
        </div>
      </footer>
    </div>
  );
}
